/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';

import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import TypographyTooltip from 'src/components/typography-tooltip';
import { bookingFindCarTabs } from 'src/pages/booking/helper';
import { AssignNhaxeFormModal } from 'src/pages/booking/sections/booking-result/booking-request-form';
import { setPushResponseFocusToBookingRequest, setPushResponseToBookingRequest } from 'src/pages/booking/slices/booking-slice';
import BookingWrapMessage from './booking-wrap-message';
import CircleColor from '../circle-color';
import LicensePlate from '../license-plate';
import LicensePlateColor from '../license-plate-color';

const BookingRequestAcceptedNotice = ({ toastId, content, userConfirm = {}, handleHideToast, handleShowToast }) => {
  console.log('BookingRequestAcceptedNotice', content);
  const userConfirmId = userConfirm.id;
  const requestId = content.id;
  const bookingCondition = content.bookingCondition;
  const requestCar = get(content, 'requestCar');
  const ownerName = get(userConfirm, 'displayName', '');

  const dispatch = useDispatch();
  const [modelForm, setModelForm] = useState({
    open: false,
    params: {}
  });

  const handleOpenAssign = useCallback(
    (assigned) => {
      const requestCar = get(content, 'requestCar');
      handleHideToast();
      setModelForm({
        open: true,
        params: {
          ownerName,
          assigned,
          requestId: content.id,
          conditionId: bookingCondition.id,
          start: content.start,
          end: content.end,
          requestCar
        }
      });
    },
    [content, ownerName, bookingCondition.id, handleHideToast]
  );

  const handleCloseModelForm = useCallback(() => {
    setModelForm({
      open: false,
      params: {}
    });

    toast.remove(toastId);
    handleShowToast();
  }, [toastId, requestId, handleShowToast]);

  const openRequestNoticeFocus = useCallback((requestId, tab) => {
    dispatch(
      setPushResponseFocusToBookingRequest({
        tab: tab,
        bookingFindCarTab: bookingFindCarTabs.carResponse.value,
        requestId
      })
    );
    toast.remove(toastId);
  }, []);

  useEffect(() => {
    if (toastId) {
      dispatch(setPushResponseToBookingRequest({ requestId, userConfirmId, isAccepted: true, bookingConditionId: bookingCondition.id }));
    }
  }, [toastId, requestId, userConfirmId, bookingCondition.id]);

  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'success.main' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={0.5}>
              <Typography variant="body2">Nhà xe </Typography>
              <Typography variant="h6" color="success.main">
                {ownerName}
              </Typography>
              <Typography variant="body2">đã nhận kèo.</Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="primary.main"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleOpenAssign(userConfirmId);
                }}
              >
                Chốt kèo
              </Typography>
              {/* <Typography variant="caption"> đã nhận</Typography> */}
            </Stack>
            <Stack
              direction="row"
              columnGap={1}
              justifyContent="space-between"
              width="100%"
              // alignItems="baseline"
            >
              <Typography
                sx={{
                  mr: 0.5,
                  textDecoration: 'underline',
                  cursor: 'pointer'
                  // animation: ' breathe 4s infinite both',
                  // animation: 'text-shake 0.8s ease-in-out infinite'
                }}
                variant="subtitle1"
                {...(toastId && {
                  onClick: () => {
                    openRequestNoticeFocus(content.id, { id: bookingCondition.id, name: bookingCondition.name });
                  }
                })}
              >
                {content.tagKey}
              </Typography>
            </Stack>
            {requestCar && (
              <BookingWrapMessage borderColor="warning.main">
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Xe :</Typography>
                  <Typography variant="subtitle2" color="primary.main">
                    {requestCar?.model?.name}
                    {` (${requestCar.inServiceYear})`}
                  </Typography>
                </Stack>
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Biển số :</Typography>
                  <LicensePlateColor licensePlate={requestCar.licensePlate} color={requestCar.color} />

                  {/* <Typography variant="subtitle2" color="primary.main">
                    {requestCar.licensePlate}
                  </Typography> */}
                </Stack>
              </BookingWrapMessage>
            )}
            <BookingWrapMessage>
              <TypographyTooltip mixText={content.message} maxLines={5} variant="body2" />
            </BookingWrapMessage>
            {/* 
                  <Typography sx={{ mr: 0.5 }} variant="body2">
                    {request.message}
                  </Typography> */}
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />

      <AssignNhaxeFormModal open={modelForm.open} {...modelForm.params} handleClose={handleCloseModelForm} />
    </>
  );
};

export default BookingRequestAcceptedNotice;
